"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OuterRimUniversity = void 0;
var Card_1 = require("../../Card");
var CardName_1 = require("../../../CardName");
var CardType_1 = require("../../CardType");
var Tags_1 = require("../../Tags");
var OrOptions_1 = require("../../../inputs/OrOptions");
var SelectOption_1 = require("../../../inputs/SelectOption");
var CardRenderer_1 = require("../../render/CardRenderer");
var DeferredAction_1 = require("../../../deferredActions/DeferredAction");
var SelectCard_1 = require("../../../inputs/SelectCard");
var OuterRimUniversity = (function (_super) {
    __extends(OuterRimUniversity, _super);
    function OuterRimUniversity() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.OUTER_RIM_UNIVERSITY,
            tags: [Tags_1.Tags.JOVIAN, Tags_1.Tags.SPACE],
            cost: 10,
            metadata: {
                cardNumber: 'L418',
                victoryPoints: 1,
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('When you play a Jovian tag, including this, you may discard a card from hand to draw a card.', function (eb) {
                        eb.jovian().played.startEffect.minus().cards(1).nbsp.plus().cards(1);
                    });
                }),
            },
        }) || this;
    }
    OuterRimUniversity.prototype.play = function () {
        return undefined;
    };
    OuterRimUniversity.prototype.getVictoryPoints = function () {
        return 1;
    };
    OuterRimUniversity.prototype.onCardPlayed = function (player, card) {
        var _this = this;
        var jovianTags = card.tags.filter(function (tag) { return tag === Tags_1.Tags.JOVIAN; }).length;
        for (var i = 0; i < jovianTags; i++) {
            player.game.defer(new DeferredAction_1.DeferredAction(player, function () {
                if (player.cardsInHand.length === 0) {
                    return undefined;
                }
                var selectCardtoDiscard = new SelectCard_1.SelectCard('Select a card to discard', 'Discard', player.cardsInHand, function (foundCards) {
                    player.cardsInHand.splice(player.cardsInHand.indexOf(foundCards[0]), 1);
                    player.game.dealer.discard(foundCards[0]);
                    player.game.log('${0} is using their ${1} effect to draw a card.', function (b) { return b.player(player).card(_this); });
                    player.game.log('You discarded ${0}', function (b) { return b.card(foundCards[0]); }, { reservedFor: player });
                    player.drawCard();
                    return undefined;
                });
                selectCardtoDiscard.buttonDanger = true;
                return new OrOptions_1.OrOptions(selectCardtoDiscard, new SelectOption_1.SelectOption('Do nothing', 'Confirm', function () {
                    return undefined;
                }));
            }));
        }
        return undefined;
    };
    return OuterRimUniversity;
}(Card_1.Card));
exports.OuterRimUniversity = OuterRimUniversity;
//# sourceMappingURL=OuterRimUniversity.js.map